import { create } from '@bufbuild/protobuf';

import * as pbm from '@/grpc-gen/message_preferences_pb';

export enum MessageTranslationKey {
  Heading = 'msngr-tx.text-blocks.heading',
  Footer = 'msngr-tx.text-blocks.footer',
  FixedEndingTimeNote = 'msngr-tx.text-blocks.fixed-ending-note',
}

export default class MessageTranslation {
  id: number = 0;

  locale: string = '';

  textKey: string = '';

  textValue: string = '';

  defaultFormalTextValue: string = '';

  defaultInformalTextValue: string = '';

  static fromGrpcModel(o?: pbm.MessageTranslation): MessageTranslation {
    const translation = new MessageTranslation();

    translation.locale = o?.locale ?? '';
    translation.textKey = o?.textKey ?? '';
    translation.textValue = o?.textValue ?? '';
    translation.defaultFormalTextValue = o?.defaultFormalTextValue ?? '';
    translation.defaultInformalTextValue = o?.defaultInformalTextValue ?? '';

    return translation;
  }

  static toGrpcModel(translation: MessageTranslation): pbm.MessageTranslation {
    return create(pbm.MessageTranslationSchema, {
      locale: translation.locale ?? '',
      textKey: translation.textKey ?? '',
      textValue: translation.textValue ?? '',
      defaultFormalTextValue: '',
      defaultInformalTextValue: '',
    });
  }
}
